<template>
<div @click="handleClick">
    <div v-if="opts" class="img-container" ref="imgContainer" >
        <div class="img-wrap" ref="imgWrap">
            <img  :src="opts.img ? opts.img.url : '' " ref="mainImg" @load="handleImgLoad"/>
            <marker-overlay v-for="category in opts.categories"
                            :key="category.id"
                            ref="markerOverlay"
                            class="marker-overlay"
                            :category="category"
                            :hooks="hooks"

            >
            </marker-overlay>
        </div>
        <div class="togglebox-wrap">
            <toggle-box :category-groups="opts.categories"
                        :title="opts.toggleHeader"
                        ref="toggleBox"

            />
            <a
                    v-if="opts.toggleButtonText"
                    :href="opts.toggleButtonLink"
                    class="togglebox-extra-button"
                    :target="opts.toggleButtonTarget"
            >
                {{opts.toggleButtonText}}
            </a>
        </div>

    </div>
    <toggle-box :category-groups="opts.categories"
                :title="opts.toggleHeader"
                ref="toggleBox"
                class="togglebox-mobile"
    />
</div>

</template>

<script>
import LabelMarker from './LabelMarker.vue';
import ToggleBox from './ToggleBoxVuex.vue';
import MarkerOverlay from './MarkerOverlayVuex.vue';
import { hooks } from '../mixins/hooks.js';


export default {
  name: 'IntImage',
  components : {
    'label-marker': LabelMarker,
    'toggle-box':ToggleBox,
    'marker-overlay': MarkerOverlay
  },
   mixins: [hooks],
  data () {
    return {
        imgW: 0,
        imgH: 0,
    }
  },
  props : ['hooks'],
  methods : {
      handleImgLoad(){
          if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
              const evt = document.createEvent('UIEvents');
              evt.initUIEvent('resize', true, false, window, 0);
              window.dispatchEvent(evt);
          } else {
              window.dispatchEvent(new Event('resize'));

          }
      },
      handleClick(e){
               // console.log(e.target);
                //console.log(this.$refs);
            },

  },
  mounted(){
     // console.log();
      this.$nextTick( ()=>{this.doHook('intImgMount');} );
      
      /*
    EventBus.$on('sctm', (marker)=>{
      this.$el.querySelector('#'+marker).focus();
    });

    this.$nextTick( function () {
        window.addEventListener('resize', ()=>{this.getImgWidth()} );
        window.addEventListener('resize',()=>{this.getImgHeight()} );
    });
      this.getImgWidth();
      this.getImgHeight();

*/
  },

    created (){

    },
    computed : {
        opts (){
            return this.$store.getters.opts;
        },
        visibleCats (){ return this.$store.getters.rtVisCats },





    }
}
</script>

<style scoped lang="scss">
  img{ height: auto;vertical-align: middle}
  .img-container{position: relative;}

</style>


// WEBPACK FOOTER //
// src/components/IntImageVuex.vue